export const DONT_SHOW_CONFERENCE_FEEDBACK_STORAGE_KEY =
  'dontShowConferenceFeedbackKey';
